import { Array } from 'stdlib/Array'

import type { TOs } from '../definitions'
import { WINDOWS_OSS } from '../definitions'

/**
 * Az OS Windows?
 * @param os - Os típusa.
 */
export default function isWindows (os: TOs): boolean {
  return Array.includes(WINDOWS_OSS, os)
}
